/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateWorkPatternData
 */
export interface UpdateWorkPatternData {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkPatternData
     */
    name?: string;
    /**
     * An array representing which days of the week are working days. 0 = Sunday, 6 = Saturday.
     * @type {Array<boolean>}
     * @memberof UpdateWorkPatternData
     */
    pattern?: Array<boolean>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWorkPatternData
     */
    isPrimary?: boolean;
}

/**
 * Check if a given object implements the UpdateWorkPatternData interface.
 */
export function instanceOfUpdateWorkPatternData(value: object): value is UpdateWorkPatternData {
    return true;
}

export function UpdateWorkPatternDataFromJSON(json: any): UpdateWorkPatternData {
    return UpdateWorkPatternDataFromJSONTyped(json, false);
}

export function UpdateWorkPatternDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWorkPatternData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'pattern': json['pattern'] == null ? undefined : json['pattern'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
    };
}

  export function UpdateWorkPatternDataToJSON(json: any): UpdateWorkPatternData {
      return UpdateWorkPatternDataToJSONTyped(json, false);
  }

  export function UpdateWorkPatternDataToJSONTyped(value?: UpdateWorkPatternData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'pattern': value['pattern'],
        'isPrimary': value['isPrimary'],
    };
}

